module.exports = __webpack_public_path__ + "static/final.210e021e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/layout/final.png
// module id = 97
// module chunks = 6972000345134 18027074326707 254612692524329